<script>
  import { onMount, afterUpdate } from "svelte";
  import { Form, FormGroup, Label, Input, Spinner, Button} from "sveltestrap";

  import { mapOrder } from '../utils/utils';
  import config from '../config.json';
import { _ } from "svelte-i18n";

    export let onSubmit;
    export let name;
    export let form;
    export let submitting;

   
  let fetched;
  let isLoading = false;

  const fetchFromBackend = async (idTags) => {
    const ids = Object.values(idTags);
    
    fetch(config.urlBase)
      .then((res) => {
        if (!res.ok) {
          throw new Error("API does not respond");
        } else {
          return res.json();
        }
      })
      .then((data) => {
        //console.log(data);
        const orderedFetched = mapOrder(
          data.filter((centr) => {
            // console.log(centr.idtag);
            if (ids.includes(centr.idtag)) {
              return centr;
            }
          }),
          ids,
          "idtag"
        );
        fetched = [...orderedFetched];
        //console.log(fetched);
        //fetched = [...mapOrder(fetched,ids,'idtag')];
        //console.log(fetched);
        form.device = fetched[0].idtag;
      })
      .catch((err) => console.log(err.message));
    isLoading = false;
  };

  onMount(async () => {
    await fetchFromBackend(config.ids);
  });

  //afterUpdate(() => console.log(submitting));
</script>

<form {name} on:submit|preventDefault={onSubmit}>
  <FormGroup>
    <Label for="device">{$_("selectDevice")}</Label>
    {#if !isLoading && fetched}
      <Input type="select" name="device" id="device" bind:value={form.device}>
        {#each fetched as device}
          <option value={device.idtag}>{device.name}</option>
        {/each}
      </Input>
    {/if}
  </FormGroup>
  <FormGroup>
    <Label for="from">From:</Label>
    <Input type="date" name="from" id="from" bind:value={form.fromDate}/>
    <Label for="to">To:</Label>
    <Input type="date" name="to" id="to" bind:value={form.toDate} />
  </FormGroup>
  <div class="text-center">
  <Button size="lg" type="submit">
  {#if submitting}
  <Spinner />
  {:else}
   {$_("submit")}
  {/if}

  </Button>
</div>
</form>

